import { createFileRoute } from '@tanstack/react-router';

import { Spinner } from '@workspace/ui/components/spinner';

import { OAUTH_REDIRECT_URL } from '~/config/environment';
import { useRemoteApp } from '~/hooks/use-remote-app';
import { m } from '~/paraglide/messages.js';

export const Route = createFileRoute('/_public/auth/$')({
  validateSearch: (): { redirect?: string } => {
    return {
      redirect: OAUTH_REDIRECT_URL,
    };
  },
  component: RouteComponent,
});

const PARENT_ELEMENT_ID = 'auth';

function RouteComponent() {
  const { loading } = useRemoteApp({
    parentElementId: PARENT_ELEMENT_ID,
    remoteName: 'mfe_bloque_auth',
    componentName: 'AuthApp',
    eventListenerToRoutes: true,
  });

  return (
    <>
      <div id={PARENT_ELEMENT_ID} />
      {loading && <Spinner message={m['common.thinking']()} />}
    </>
  );
}
